import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Label = styled.div`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.semibold};
  `}

  ${({ theme }) => media.sm`
    padding-bottom: ${theme.space.desktop.nano};
  `}
`

export const Text = styled.div`
  ${({ theme }) => `
    font-weight: ${theme.fontWeight.normal};
    padding-top: ${theme.space.mobile.nano};
  `}

  ${({ theme }) => media.sm`
    padding-top: calc(${theme.space.desktop.nano} * 2);
  `}
`
